import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  MenuButton,
  MenuList,
  Icon,
  Flex,
  Text,
} from "@chakra-ui/react";
import { FaCaretDown } from "react-icons/fa6";
import {
  newBorder,
  textSecondary,
  white,
  backgroundLight,
  primary,
  primaryAlt,
  textPrimary,
} from "../../utils/colors";
import { shade } from "polished";
import { size } from "lodash";

const DropdownButtonAlt = ({
  initialLabel,
  items,
  onSelectItem,
  iconComponent,
  size,
  isFullWidth,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(initialLabel);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  const handleMenuItemClick = (item) => {
    onSelectItem(item);
    setSelectedLabel(item); // Update the label with the selected item
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedLabel(initialLabel);
  }, [initialLabel]);

  // console.log("initialLabel", initialLabel);
  // console.log("selectedLabel", selectedLabel);

  return (
    <Box p={0} borderRadius="0.75rem" w={isFullWidth ? "100%" : "initial"}>
      <Menu
        isLazy
        onOpen={handleMenuOpen}
        onClose={handleMenuClose}
        w={isFullWidth ? "100%" : "initial"}
      >
        <MenuButton
          as={Button}
          bg={textPrimary}
          color={white}
          border={`0px solid ${newBorder}`}
          display="flex"
          w={["100%", "initial"]}
          alignItems="center"
          justifyContent="center"
          borderRadius="10.75rem"
          size={size ? size : "md"}
          p="0rem 0.75rem"
          // position="relative"
          // top="0.25rem"
          transition="0.2s all"
          _hover={{ bg: primaryAlt }}
          _active={{ bg: primaryAlt }}
          cursor="pointer"
          onClick={() => setIsOpen(!isOpen)}
        >
          <Flex align="center" justify={["center", "initial"]}>
            {iconComponent && <Box mr={2}>{iconComponent}</Box>}
            <Text fontSize="sm" fontWeight="500 ">
              {selectedLabel}
            </Text>
            <Icon
              as={FaCaretDown}
              ml={1}
              h="0.75rem"
              w="0.75rem"
              transition="all 0.2s ease"
              transform={isOpen ? "rotate(180deg)" : "rotate(0)"}
            />
          </Flex>
        </MenuButton>
        <MenuList
          p={0}
          m={0}
          borderRadius="1rem"
          maxWidth={["100%", "100px"]}
          maxHeight={["369px"]}
          w={["100%", "100px"]}
          overflow="scroll"
        >
          {items.map((item, index) => (
            <MenuItem
              key={index}
              w={["100%", "100%"]}
              py={3}
              px={4}
              borderBottom={`1px solid ${newBorder}`}
              color={textSecondary}
              _hover={{ bg: primary, color: "white" }}
              onClick={() => handleMenuItemClick(item)}
            >
              <Text fontWeight="500" fontSize="sm">
                {item}
              </Text>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default DropdownButtonAlt;
